import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  // list (optional): the element holding the rows. Set when the add link sits outside it,
  // so a new row joins its siblings (a sortable block list) instead of landing beside it.
  static targets = ["links", "template", "list"]
  // A nested nested-form (rates inside a Lohngruppe) needs its own placeholder,
  // or the outer add would stamp the inner template's index too.
  static values = { placeholder: { type: String, default: "NEW_RECORD" } }

  connect() {
    this.wrapperClass = this.data.get("wrapperClass") || "nested-fields"
  }

  add_association(event) {
    event.preventDefault()
    // replaceAll with a STRING replaces every occurrence literally — no regex, so a
    // placeholder carrying a metacharacter cannot turn into a pattern that matches the
    // wrong thing (or nothing at all).
    const content = this.templateTarget.innerHTML.replaceAll(
      this.placeholderValue,
      String(new Date().getTime()),
    )
    if (this.hasListTarget && !this.listTarget.contains(this.linksTarget)) {
      this.listTarget.insertAdjacentHTML("beforeend", content)
    } else {
      this.linksTarget.insertAdjacentHTML("beforebegin", content)
    }
  }

  remove_association(event) {
    event.preventDefault()

    const wrapper = event.target.closest("." + this.wrapperClass)

    // New records are simply removed from the page
    if (wrapper.dataset.newRecord == "true") {
      wrapper.remove()

      // Existing records are hidden and flagged for deletion
    } else {
      wrapper.querySelector("input[name*='_destroy']").value = 1
      wrapper.style.display = "none"
    }

    // Trigger recalculation in any co-located hours controller via its native change listener
    this.element.dispatchEvent(new Event("change", { bubbles: false }))
  }
}
